import React from "react"
import Cell from "./Cell"

const getCorner = ({ section, colIndex, columnCount }) => {
  if (section === "head") {
    if (colIndex === 0) return "top-left"
    if (colIndex === columnCount - 1) return "top-right"
  }
  if (section === "foot") {
    if (colIndex === 0) return "bottom-left"
    if (colIndex === columnCount - 1) return "bottom-right"
  }
  return ""
}

export default function Row({
  row,
  columnCount = 1,
  section = "body",
  centered = false,
  gondolaType = "",
}) {
  const columns = row?.column || []
  return (
    <div
      className={`row${section === "head" ? " head-row" : ""}${
        section === "foot" ? " foot-row" : ""
      }`}
      style={{ gridTemplateColumns: `repeat(${columnCount}, 1fr)` }}
    >
      {columns.map((cell, index) => (
        <Cell
          contentType={`${section === "head" ? "H" : ""}${
            section === "foot" ? "F" : ""
          }`}
          key={`${section}-${row?.rowIndex || 0}-${index}`}
          item={cell}
          corner={getCorner({ section, colIndex: index, columnCount })}
          centered={centered || columnCount === 1}
          gondolaType={gondolaType}
        />
      ))}
    </div>
  )
}
